import styled from "styled-components";
import fontSizes from "../../../../../styles/fontSizes";
import ClickableElement from "../../../../utils/ClickableElement";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${fontSizes.regular};
  align-items: center;
  gap: 0.5rem;
`;

export const EditButton = styled(ClickableElement)`
  width: auto;
`;

export const DragSourceContainer = styled.div`
  cursor: move;
  display: flex;
  align-items: center;
`;
